import { CRITTERS, MISSIONS } from "../../data/dolopals";

export const normalizeExp = (parsed) => {
  if (parsed && typeof parsed === "object") {
    return {
      shards: Number(parsed.shards) || 0,
      fragments: Number(parsed.fragments) || 0,
      xp: parsed.xp && typeof parsed.xp === "object" ? parsed.xp : {},
      active: parsed.active && typeof parsed.active === "object" ? parsed.active : {},
      owned: Array.isArray(parsed.owned) ? parsed.owned : [],
      frame: parsed.frame || null,
      banner: parsed.banner || null,
      daub: parsed.daub || null,
      stamp: parsed.stamp || null,
      caught: Number(parsed.caught) || 0,
      defenseBest: Number(parsed.defenseBest) || 0,
      megaKills: Number(parsed.megaKills) || 0,
      week:
        parsed.week && typeof parsed.week === "object"
          ? {
              key: parsed.week.key || null,
              caught: Number(parsed.week.caught) || 0,
              megaKills: Number(parsed.week.megaKills) || 0,
              critters: Number(parsed.week.critters) || 0,
              streak: Number(parsed.week.streak) || 0,
            }
          : null,
      critterDupes: parsed.critterDupes && typeof parsed.critterDupes === "object" && !Array.isArray(parsed.critterDupes) ? parsed.critterDupes : {},
      shinies: Array.isArray(parsed.shinies) ? parsed.shinies.filter((id) => typeof id === "string") : [],
      shinyDupes: parsed.shinyDupes && typeof parsed.shinyDupes === "object" && !Array.isArray(parsed.shinyDupes) ? parsed.shinyDupes : {},
      sundayShinies: Number(parsed.sundayShinies) || 0,
      quizBest: Number(parsed.quizBest) || 0,
      matchBest: Number(parsed.matchBest) || 0,
      treasure: parsed.treasure || null,
      critters: Array.isArray(parsed.critters) ? parsed.critters.filter((id) => typeof id === "string") : [],
      outpost: typeof parsed.outpost === "string" && parsed.outpost.trim() ? parsed.outpost.slice(0, 18) : null,
      skin: parsed.skin || null,
      daily:
        parsed.daily && typeof parsed.daily === "object"
          ? { last: parsed.daily.last || null, streak: Number(parsed.daily.streak) || 0 }
          : { last: null, streak: 0 },
    };
  }
  return { shards: 0, fragments: 0, xp: {}, active: {}, owned: [], frame: null, banner: null, daub: null, stamp: null, caught: 0, defenseBest: 0, megaKills: 0, week: null, critterDupes: {}, shinies: [], shinyDupes: {}, sundayShinies: 0, quizBest: 0, matchBest: 0, treasure: null, critters: [], outpost: null, skin: null, daily: { last: null, streak: 0 } };
};

// one mission zone pays double shards each day — deterministic daily rotation

export const signalOfTheDay = () => MISSIONS[Math.floor(Date.now() / 86400000) % MISSIONS.length].id;

// BOSS FRIDAY — mega worms surge every Friday (local time)

export const isBossFriday = () => new Date().getDay() === 5;

// TRADE TUESDAY — critter trades pay double every Tuesday (local time)

export const isTradeTuesday = () => new Date().getDay() === 2;

// SHINY SUNDAY — shiny critter odds triple all day Sunday (local time)

export const isShinySunday = () => new Date().getDay() === 0;

// BOSS EVE — Thursday warning: the mega worm surge starts at midnight

export const isBossEve = () => new Date().getDay() === 4;

// shiny spawn odds — tripled all day Sunday

export const shinyOdds = () => (isShinySunday() ? 0.24 : 0.08);

// CRITTER OF THE WEEK — one species gets the spotlight and wanders in far more often

export const critterOfTheWeek = () => CRITTERS[Math.floor(Date.now() / 604800000) % CRITTERS.length];

// ISO week key (matches the backend defense crown week format)

export const weekKeyNow = () => {
  const d = new Date();
  const t = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  const day = (t.getUTCDay() + 6) % 7;
  t.setUTCDate(t.getUTCDate() - day + 3);
  const first = new Date(Date.UTC(t.getUTCFullYear(), 0, 4));
  const week = 1 + Math.round(((t - first) / 86400000 - 3 + ((first.getUTCDay() + 6) % 7)) / 7);
  return `${t.getUTCFullYear()}-W${String(week).padStart(2, "0")}`;
};

// one trade cashes a duplicate critter for this many shards (doubled on Tuesdays)

export const tradeValue = () => (isTradeTuesday() ? 30 : 15);

export const titanLevel = (xp) => 1 + Math.floor((xp || 0) / 60);

export const fmt = (ms) => {
  const s = Math.max(0, Math.ceil(ms / 1000));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
};

export const RADAR_SKINS = {
  default: { line: "120, 255, 160", glow: "#78ffa0" },
  "skin-cyan": { line: "0, 200, 255", glow: "#6ee7ff" },
  "skin-pink": { line: "255, 92, 216", glow: "#ff9df5" },
  "skin-amber": { line: "255, 153, 0", glow: "#ffb84d" },
};

// critter silhouette shapes — each creature's true outline, drawn in its color when adopted
// and as a dark silhouette while still hiding (64x48 viewBox)

export const radarDayKey = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

// deterministic daily cache position — same spot for every kid on a given day

export const treasureFor = (dateKey) => {
  let h = 0;
  for (let i = 0; i < dateKey.length; i += 1) h = (h * 31 + dateKey.charCodeAt(i)) >>> 0;
  return { ang: ((h % 1000) / 1000) * Math.PI * 2, dist: 0.25 + (((h >> 10) % 1000) / 1000) * 0.65 };
};

// fever ignition sting — rising major arpeggio
